<mat-sidenav-container>
  <mat-sidenav
    class="save-search"
    style="width: 60%"
    #sidenav
    mode="over"
    position="end"
    [opened]="addPropertySearchValue"
    disableClose
  >
    <div class="sliding-sheet-header">
      <h4>Add Searches</h4>
      <button type="button" (click)="closePropertySearchSheet()"><mat-icon>close</mat-icon></button>
    </div>

    <div class="sliding-sheet-body">
      <form [formGroup]="saveSearchForm">
        <div class="row mt-1">
          <div class="col-md-3 col-4">
            <label class="mt-3 field-label pr-0">Saved Search Name :</label>
          </div>
          <div class="col-md-5 col-8 pl-0">
            <mat-form-field class="w-100">
              <input matInput tabindex="1" formControlName="searchName" autocomplete="off" />
              <mat-error *ngIf="searchNameCtrl.hasError('required')">
                Search name is <strong>required</strong>
              </mat-error>
              <mat-error *ngIf="searchNameCtrl.hasError('duplicate')"> Name already <strong>exists</strong> </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-3 col-4">
            <label class="mt-3 field-label pr-0">Select Location :</label>
          </div>
          <div class="col-md-5 col-8 pl-0">
            <mat-form-field class="w-100">
              <input
                matInput
                type="text"
                formControlName="addressSearch"
                name="autocompleteInput"
                class="search_field"
                #searchField
                [(ngModel)]="autoCompleteInput"
                required
                tabindex="2"
                googleAutocomplete
                autocomplete="off"
                (addressComponents)="getAddressComponents($event)"
              />
              <mat-error *ngIf="addressSearchCtrl.hasError('required')">
                Location is <strong>required</strong>
              </mat-error>
              <mat-error *ngIf="addressSearchCtrl.hasError('invalid')">
                Enter a <strong>valid</strong> location
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <br /><br />
        <button class="all-filter-btn" (click)="propertyFilterService.toggleFilterSheet()">
          <span>+ Select Filters to Apply </span>
        </button>
        <app-all-filter-sheet [applyToUrl]="false"></app-all-filter-sheet>
        <div>
          <mat-chip-list class="example-chip" cdkDropList cdkDropListOrientation="horizontal">
            <mat-chip class="applied-filter" *ngFor="let filter of appliedFilters">
              {{ filter.key }}: <b>{{ filter.value }}</b>
            </mat-chip>
          </mat-chip-list>
        </div>
        <!-- <app-active-filter class="h-filter" [disableSavedSearch]="disableSavedSearch"></app-active-filter> -->
        <br />
        <button
          tabindex="4"
          class="my-2 mt-3 save_search"
          type="button"
          color="primary"
          mat-flat-button
          [disabled]="!showSaveSearchBtn"
          [pmx-progress-button]="isSaveSearchInProgress"
          (click)="saveSearch()"
        >
          Save Search
        </button>
      </form>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
